import * as React from 'react';
import {
  motion,
} from 'framer-motion';

import {
  Colors,
  Breakpoint,

  useDimensions,

  LargeContainer,
  ContentContainer,
} from '@bluecurrent/web-component-lib';

import Image from './Modules/Image';
import Background from './Modules/Background';
import Content from './Modules/Content';
import OrderEnergyForm from '../../OrderEnergyForm';

export default function EnergyAnimated(props) {
  const size = useDimensions();

  const ref = React.useRef(null);

  const [width, setWidth] = React.useState('100%');

  const height = size.width < Breakpoint.md ? 'auto' : '65svh';

  const getDimensions = () => {
    if (ref.current.clientWidth !== null) setWidth(ref.current.clientWidth);
  };

  React.useEffect(() => {
    getDimensions();
  }, [width]);

  React.useEffect(() => {
    window.addEventListener('resize', getDimensions);

    return () => window.removeEventListener('resize', getDimensions);
  }, []);

  return (
    <>
      <LargeContainer>
        <motion.div
          style={{
            height,
            minWidth: 320,
            minHeight: 450,
            maxHeight: size.width < Breakpoint.md ? undefined : 650,
            position: 'relative',
            backgroundColor: Colors.GRADIENT,
            borderRadius: size.width < Breakpoint.xxl ? 0 : 15,
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
          initial={{
            opacity: 0,
          }}
          whileInView={{
            opacity: 1,
          }}
          transition={{
            duration: 0.5,
            ease: 'easeInOut',
            stiffness: 100,
          }}
          viewport={{
            once: true,
          }}
        >
          <div
            style={{
              width,
              height,
              maxHeight: size.width < Breakpoint.md ? undefined : 650,
              display: 'flex',
              flexDirection: size.width < Breakpoint.md ? 'column' : 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <div
              style={{
                width: size.width < Breakpoint.md ? '100%' : '45%',
                height: '100%',
                backgroundColor: Colors.GRADIENT,
                position: 'relative',
                zIndex: 4,
                paddingTop: 15,
                paddingBottom: 15,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Content
                data={props.data.text_block}
                params={props.params}
              />
              {
                size.width < Breakpoint.md && (
                  <div
                    style={{
                      marginTop: -15,
                    }}
                  >
                    <OrderEnergyForm />
                  </div>
                )
              }
            </div>
            {
              size.width >= Breakpoint.md && (
                <div
                  style={{
                    height,
                    minHeight: 500,
                    maxHeight: size.width < Breakpoint.md ? undefined : 650,
                    width: size.width < Breakpoint.md ? '100%' : '55%',
                    position: 'relative',
                    overflow: 'hidden',
                  }}
                >
                  <Image
                    height={height}
                  />
                </div>
              )
            }
          </div>
          <Background
            height={height}
          />
        </motion.div>
      </LargeContainer>
      <ContentContainer>
        <div
          ref={ref}
          style={{
            width: '100%',
            marginTop: -60,
            position: 'relative',
            zIndex: 4,
          }}
        >
          {
            size.width >= Breakpoint.md && (
              <OrderEnergyForm />
            )
          }
        </div>
      </ContentContainer>
    </>
  );
}
